import React from 'react';
import { IoMdRefresh } from "react-icons/io";
interface ChatErrorFallbackProps {
  error: Error;
  resetError?: () => void;
  title?: string;
  message?: string;
}

export const ChatErrorFallback: React.FC<ChatErrorFallbackProps> = ({
  error,
  resetError,
  title = "Chat Temporarily Unavailable",
  message = "We're experiencing technical difficulties with the chat system. Please try refreshing the page or starting a new conversation."
}) => {
  const handleRetry = () => {
    if (resetError) {
      resetError();
    } else {
      window.location.reload();
    }
  };

  const handleNewChat = () => {
    window.location.href = '/';
  };

  return (
    <div className="cpr_container_inner">
      <div className="text-center py-5 my-5">
        <div className="mb-4">
          <img
            src="https://content.harstatic.com/media/icons/a_all/chat_ai_icon2.svg"
            alt="Chat Error"
            style={{
              width: '64px',
              height: '64px',
              filter: 'grayscale(100%)',
              opacity: '0.6'
            }}
          />
        </div>

        <h3 className="text-center font_size--large font_weight--semi_bold mb-3">
          {title}
        </h3>

        <p className="font_size--medium color_auxiliary mb-4" style={{ maxWidth: '400px', margin: '0 auto' }}>
          {message}
        </p>

        <div className="d-flex justify-content-center gap-3 flex-wrap">
          <button
            onClick={handleRetry}
            className="btn btn--primary btn--medium"
          >
            {/* <img 
              src="https://content.harstatic.com/media/icons/a_all/refresh.svg" 
              alt="Retry" 
              className="mr-2"
              style={{ width: '16px', height: '16px' }}
            /> */}
            <IoMdRefresh className="mr-2" style={{ width: '20px', height: '20px' }} />
            Try Again
          </button>

          <button
            onClick={handleNewChat}
            className="btn btn--secondary btn--medium"
          >
            <img
              src="https://content.harstatic.com/media/icons/a_all/add_block_3.svg"
              alt="New Chat"
              className="mr-2"
              style={{ width: '16px', height: '16px' }}
            />
            New Chat
          </button>
        </div>

        {/* Show error details in development */}
        {process.env.NODE_ENV !== 'production' && (
          <details className="mt-4 text-center">
            <summary className="cursor-pointer font_size--small color_auxiliary">
              Error Details ({process.env.NODE_ENV === "development" ? "Development" : "Testing"} Mode)
            </summary>
            <div className="mt-2 p-3 bg-light border-radius font_size--small" style={{ fontFamily: 'monospace' }}>
              <strong>Error:</strong> {error.message}<br />
              <strong>Stack:</strong>
              <pre className="mt-1 mb-0" style={{ fontSize: '12px', whiteSpace: 'pre-wrap' }}>
                {error.stack}
              </pre>
            </div>
          </details>
        )}
      </div>
    </div>
  );
};

export default ChatErrorFallback;
